import { settings } from './settings'

/** Get list of content */
const loadContent = async (market, store) => {
	return await fetch(`${settings.backendApi}/${store}?market=${market}`)
		.then(res => {

			return res.json()
		})
		.catch(error => {
			console.error(error)
		})
}

/** Gets specific content */
const getContent = async (market, route, store) => {
	return await fetch(`${settings.backendApi}/config/${store}?market=${market}&route=${route}&limit=1`)
		.then(res => {
			if (res.status === 200){
				return res.json()
			} else return undefined
		})
		.catch(error => {
			console.error(error)
		})
}

export { loadContent, getContent }